const Planning = {
    data() {
        return {
            /*DATOS DEL FORMULARIO*/
            servicios: [],
            escenarios: [],
            ventanas: [],
            turnosServicio: [],
            /*----------------------------*/
            servicioId: null,
            loading: false,
            /*----------------------------*/
            tipoEscenario: 'transacciones',
            tipo_escenario: [
                { text: 'Transacciones Entrantes', value: 'transacciones' },
                { text: 'Transacciones Salientes', value: 'horas' },
                { text: 'Agentes', value: 'agentes' }
            ],
            nombreEscenarioSeleccionado: null,
            /*----------------------------*/
            parametros: {
                tmg: 325,
                nivel: 85,
                umbral: 20
            },
            /*----------------------------*/

            /*DATOS PLANEACION */
            planDiaModelo: [],
            tab: 0,
            diasEnOrden: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],

            items: [],
            headers: [],

        }
    },
    async mounted() {
        await this.cargarServicios();
    },
    watch: {
        servicioId(val) {
            if (val) {
                this.cargarVentanaServicio();
                this.cargarTurnos();
            }
        },
    },
    computed: {
        /**VALORES FORMULARIO */
        nombresEscenariosFiltrados() {
            if (!this.servicioId || !this.tipoEscenario || !this.escenarios.length) {
                return [];
            }
            const escenariosFiltrados = this.escenarios.filter(e =>
                e.servicio_id === this.servicioId &&
                e.tipo === this.tipoEscenario
            );
            const nombresUnicos = [...new Set(escenariosFiltrados.map(e => e.nombre))];
            return nombresUnicos;
        },
        /**VALORES PLANEACION */
        diasUnicos() {
            const dias = [...new Set(this.planDiaModelo.map(item => item.dia_semana))];
            return this.diasEnOrden.filter(d => dias.includes(d));
        },
        headersPorCampo() {
            const baseHeader = [{ text: 'Intervalo', value: 'intervalo' }];
            const headersDinamicos = this.diasUnicos.map(dia => ({ text: dia, value: dia }));

            return {
                volumen: [...baseHeader, ...headersDinamicos],
                requeridos: [...baseHeader, ...headersDinamicos],
                programados: [...baseHeader, ...headersDinamicos],
                diferencia: [...baseHeader, ...headersDinamicos]
            };
        },
        matrizPorCampo() {
            const resultado = {
                volumen: [],
                requeridos: [],
                programados: [],
                diferencia: []
            };

            // Agrupar todos los campos en una sola pasada
            const agrupado = {};

            this.planDiaModelo.forEach(item => {
                const intervalo = `${item.intervalo_inicio.slice(0, 5)} - ${item.intervalo_fin.slice(0, 5)}`;
                const dia = item.dia_semana;

                if (!agrupado[intervalo]) {
                    agrupado[intervalo] = {
                        intervalo,
                        volumen: {},
                        requeridos: {},
                        programados: {},
                        diferencia: {}
                    };
                }

                agrupado[intervalo].volumen[dia] = item.volumen;
                agrupado[intervalo].requeridos[dia] = item.requeridos;
                agrupado[intervalo].programados[dia] = item.programados;
                agrupado[intervalo].diferencia[dia] = item.diferencia;
            });

            // Convertir agrupado a listas de objetos por campo
            Object.entries(agrupado).forEach(([intervalo, datos]) => {
                const filaVol = { intervalo };
                const filaReq = { intervalo };
                const filaProg = { intervalo };
                const filaDif = { intervalo };

                this.diasUnicos.forEach(dia => {
                    filaVol[dia] = datos.volumen[dia] ?? null;
                    filaReq[dia] = datos.requeridos[dia] ?? null;
                    filaProg[dia] = datos.programados[dia] ?? null;
                    filaDif[dia] = datos.diferencia[dia] ?? null;
                });

                resultado.volumen.push(filaVol);
                resultado.requeridos.push(filaReq);
                resultado.programados.push(filaProg);
                resultado.diferencia.push(filaDif);
            });

            return resultado;
        },
    },
    methods: {
        //METODOS PRINCIPALES DE DATOS
        async cargarEscenarios() {
            this.nombreEscenarioSeleccionado = null
            const res = await this.$axios.get(`escenarios/${this.servicioId}`);
            this.escenarios = res.data;
        },
        async cargarServicios() {
            try {
                const usuarioId = this.$store.state.id;
                const res = await this.$axios.get(`list-services?usuario=${usuarioId}`);
                this.servicios = res.data;
            } catch (err) {
                console.error('Error al cargar servicios:', err);
                this.$toast.error('No se pudieron cargar los servicios');
            }
        },
        async cargarVentanaServicio() {
            const res = await this.$axios.get(`ventana-servicio/${this.servicioId}`);
            this.ventanas = res.data;
            this.diasDisponibles = res.data.map(v => v.dia_semana);
        },
        async cargarTurnos() {
            const res = await this.$axios.get(`turnos-servicio/${this.servicioId}`);
            this.turnosServicio = res.data;
        },
        /*METODO PLANEACION*/
        crearPlanDiaModelo() {
            this.loading = true;
            setTimeout(() => {
                try {
                    const datosValidos = this.validarDatosPlaneacion();
                    const servicio = this.servicios.find(s => s.id === this.servicioId);
                    if (datosValidos) {
                        /*CARGA DE DATOS DE PLANEACION */
                        const utz = parseFloat(servicio.utilizacion) / 100;
                        const abs = parseFloat(servicio.ausentismo) / 100;

                        this.planDiaModelo = this.escenariosFiltrados.map(item => {
                            const volumen = item.volumen;
                            const tmgV = item.tmg;
                            let requeridos = 0;
                            if (this.tipoEscenario === 'transacciones') {
                                const tmgConfig = parseFloat(this.parametros.tmg);
                                const tmg = (tmgV !== null && tmgV !== undefined) ? parseFloat(tmgV) : tmgConfig;

                                const nivel = parseFloat(this.parametros.nivel);
                                const umbral = parseFloat(this.parametros.umbral);

                                const sla = nivel / 100;
                                const serviceTime = umbral;
                                const callsPerHour = volumen * 2;
                                const aht = tmg;

                                requeridos = this.calcularAgentesErlangC({ sla, serviceTime, callsPerHour, aht });
                            } else if (this.tipoEscenario === 'horas') {
                                const tmgConfig = parseFloat(this.parametros.tmg);
                                const tmg = (tmgV !== null && tmgV !== undefined) ? parseFloat(tmgV) : tmgConfig;
                                const duracionIntervaloSegundos = 30 * 60;
                                requeridos = (volumen * tmg) / duracionIntervaloSegundos;
                                requeridos = parseFloat(requeridos.toFixed(2));
                            } else if (this.tipoEscenario === 'agentes') {
                                requeridos = volumen;
                            }

                            const programados = this.aplicarReductores(requeridos, utz, abs);
                            const diferencia = programados - requeridos;

                            return {
                                ...item,
                                requeridos,
                                programados,
                                diferencia
                            };
                        });
                        this.calcularAsignacionPorTurno();
                    }

                } catch (error) {
                    this.$toast.error('Ocurrió un error inesperado al generar el plan del día.');
                }
                finally {
                    this.loading = false;
                }
            }, 100)

        },
        /*METODO DE VALIDACIONES*/
        validarDatosPlaneacion() {
            /* VALIDACIONES INICIALES */
            if (!this.servicioId) {
                this.$toast.warning('Por favor, selecciona un servicio.');
                return false;
            }
            if (!this.tipoEscenario) {
                this.$toast.warning('Por favor, selecciona un tipo de escenario.');
                return false;
            }
            if (!this.nombreEscenarioSeleccionado) {
                this.$toast.warning('Debe seleccionar un Escenario Base.');
                return false;
            }
            if (this.turnosServicio.length === 0) {
                this.$toast.warning('El servicio aun no tiene turnos asignados');
                return false;
            }

            /* BÚSQUEDA Y VERIFICACIÓN DEL SERVICIO */
            const servicio = this.servicios.find(s => s.id === this.servicioId);
            if (!servicio) {
                this.$toast.error('Servicio no encontrado.');
                return false;
            }

            /* VERIFICACIÓN DE AUXILIARES */
            let auxiliares = [];
            try {
                auxiliares = JSON.parse(servicio.auxiliares);
            } catch (error) {
                this.$toast.error('Error al procesar los auxiliares del servicio.');
                console.error('Error al parsear auxiliares:', error);
                return false;
            }
            if (!Array.isArray(auxiliares) || auxiliares.length === 0) {
                this.$toast.warning('El servicio no tiene auxiliares configurados.');
                return false;
            }

            /* VERIFICACIÓN DE CAMPOS REQUERIDOS EN AUXILIARES */
            const camposRequeridos = [
                'tipo', 'duracion', 'jornada_max', 'jornada_min',
                'max_antes_fin', 'min_desde_inicio',
                'max_antes_fin_min', 'min_desde_inicio_min'
            ];
            const auxiliaresCompletos = auxiliares.every(aux => {
                return camposRequeridos.every(campo => {
                    const valor = aux[campo];
                    if (valor === undefined || valor === null) return false;
                    if (typeof valor === 'string' && valor.trim() === '') return false;
                    if (typeof valor === 'number' && isNaN(valor)) return false;
                    return true;
                });
            });
            if (!auxiliaresCompletos) {
                this.$toast.warning('Todos los auxiliares deben tener completos y válidos los campos requeridos para la planeación.');
                return false;
            }

            /* VERIFICACIÓN DE UTILIZACIÓN Y AUSENTISMO */
            if (
                servicio.utilizacion == null || servicio.ausentismo == null ||
                servicio.utilizacion === '' || servicio.ausentismo === '' ||
                parseFloat(servicio.utilizacion) <= 0 || parseFloat(servicio.ausentismo) <= 0
            ) {
                this.$toast.warning('El servicio no tiene definidos los valores de utilización o ausentismo.');
                return false;
            }

            /*VERIFICACION DE ESCENARIOS*/
            this.escenariosFiltrados = this.escenarios.filter(item => {
                return item.tipo === this.tipoEscenario &&
                    item.nombre === this.nombreEscenarioSeleccionado;
            });

            if (this.escenariosFiltrados.length === 0) {
                this.$toast.warning(`No hay escenarios para el servicio "${servicio.nombre}" 
                            con tipo "${this.tipoEscenario}" y nombre "${this.nombreEscenarioSeleccionado}".`);
                this.planDiaModelo = []; // Limpia resultados anteriores
                return;
            }
            /*VERFIICACION DE PARAMETROS DE CONFIGURACION */
            if (!this.parametros.tmg || !this.parametros.nivel || !this.parametros.umbral) {
                this.$toast.warning('Completa todos los parámetros de configuración.');
                return;
            }

            return true;
        },
        /*METODOS DE OPERACION ERLANG Y REDUCTORES */
        calcularAgentesErlangC({ sla, serviceTime, callsPerHour, aht }) {
            const birthRate = callsPerHour;
            const deathRate = 3600 / aht;
            const trafficRate = birthRate / deathRate;

            const erlangs = (birthRate * aht) / 3600;
            let noAgents = Math.max(1, Math.floor(erlangs));
            let utilisation = trafficRate / noAgents;


            while (utilisation >= 1) {
                noAgents++;
                utilisation = trafficRate / noAgents;
            }

            const maxIterate = noAgents * 100;
            const maxAccuracy = 0.01;

            for (let count = 1; count <= maxIterate; count++) {
                utilisation = trafficRate / noAgents;
                if (utilisation < 1) {
                    const C = this.calcularErlangC(noAgents, trafficRate);
                    let slQueued = 1 - C * Math.exp((trafficRate - noAgents) * serviceTime / aht);
                    slQueued = Math.max(0, slQueued);

                    if (slQueued >= sla || slQueued > 1 - maxAccuracy) break;
                }
                noAgents++;
            }

            return noAgents;
        },
        calcularErlangC(servers, intensity) {
            const B = this.calcularErlangB(servers, intensity);
            const utilisation = intensity / servers;

            const C = B / ((utilisation * B) + (1 - utilisation));
            return this.minMax(C, 0, 1);
        },
        calcularErlangB(servers, intensity) {
            let B = 1;
            for (let i = 1; i <= servers; i++) {
                B = (intensity * B) / (i + intensity * B);
            }
            return this.minMax(B, 0, 1);
        },
        minMax(val, min, max) {
            return Math.max(min, Math.min(val, max));
        },
        aplicarReductores(agentes, utz, abs) {
            if (utz <= 0 || abs >= 1) return agentes;

            const k12 = (agentes / 2) / utz;

            const t12 = Math.round((k12 * 2) / (1 - abs));

            return t12;

        },
        /**METODOS DE EDICION DE DATOS DE PLANEACION */
        actualizarVolumen(intervalo, dia, nuevoVolumen) {
            // Buscar el item original en planDiaModelo
            const itemOriginal = this.planDiaModelo.find(item => {
                const intervaloTexto = `${item.intervalo_inicio.slice(0, 5)} - ${item.intervalo_fin.slice(0, 5)}`;
                return intervaloTexto === intervalo && item.dia_semana === dia;
            });

            if (itemOriginal) {
                itemOriginal.volumen = parseFloat(nuevoVolumen);
                const tmgV = itemOriginal.tmg;

                // Recalcular requeridos, programados y diferencia
                const servicio = this.servicios.find(s => s.id === this.servicioId);
                const utz = parseFloat(servicio.utilizacion) / 100;
                const abs = parseFloat(servicio.ausentismo) / 100;

                let requeridos = 0;

                if (this.tipoEscenario === 'transacciones') {
                    //const tmg = parseFloat(this.parametros.tmg);
                    const tmgConfig = parseFloat(this.parametros.tmg);
                    const tmg = (tmgV !== null && tmgV !== undefined) ? parseFloat(tmgV) : tmgConfig;

                    const nivel = parseFloat(this.parametros.nivel);
                    const umbral = parseFloat(this.parametros.umbral);

                    const sla = nivel / 100;
                    const serviceTime = umbral;
                    const callsPerHour = itemOriginal.volumen * 2;
                    const aht = tmg;

                    requeridos = this.calcularAgentesErlangC({ sla, serviceTime, callsPerHour, aht });

                } else if (this.tipoEscenario === 'horas') {
                    //const tmg = parseFloat(this.parametros.tmg);
                    const tmgConfig = parseFloat(this.parametros.tmg);
                    const tmg = (tmgV !== null && tmgV !== undefined) ? parseFloat(tmgV) : tmgConfig;
                    const duracionIntervaloSegundos = 30 * 60;
                    requeridos = (itemOriginal.volumen * tmg) / duracionIntervaloSegundos;
                    requeridos = parseFloat(requeridos.toFixed(2));
                } else if (this.tipoEscenario === 'agentes') {
                    requeridos = itemOriginal.volumen;
                }

                const programados = this.aplicarReductores(requeridos, utz, abs);
                const diferencia = programados - requeridos;

                itemOriginal.requeridos = requeridos;
                itemOriginal.programados = programados;
                itemOriginal.diferencia = diferencia;

                // Forzar actualización de matriz
                this.$forceUpdate();
                /*this.calcularAsignacionPorTurno();*/
            }
        },

        /**Asignacion */
        calcularAsignacionPorTurno() {
            const demandaIndexada = this.indexarDemanda(this.planDiaModelo);

            let coberturaActual = new Array(demandaIndexada.length).fill(0);
            const turnosMapeados = this.turnosServicio.map(t => ({
                ...t,
                cobertura: this.mapearCoberturaTurno(t, demandaIndexada)
            }));

            let turnosRequeridos = this.turnosServicio.reduce((acc, t) => {
                acc[t.nombre] = 0;
                return acc;
            }, {});

            let iteraciones = 0;
            const MAX_ITERACIONES = 5000;

            while (this.haySubCobertura(demandaIndexada, coberturaActual) && iteraciones < MAX_ITERACIONES) {

                let mejorTurno = null;
                let maxImpacto = -Infinity;
                let mejorCoberturaMapeada = null;

                for (const turno of turnosMapeados) {
                    const impacto = this.evaluarImpacto(demandaIndexada, coberturaActual, turno.cobertura);

                    if (impacto > maxImpacto) {
                        maxImpacto = impacto;
                        mejorTurno = turno;
                        mejorCoberturaMapeada = turno.cobertura;
                    }
                }

                if (mejorTurno && maxImpacto > 0) {
                    turnosRequeridos[mejorTurno.nombre] += 1;
                    coberturaActual = this.sumarCobertura(coberturaActual, mejorCoberturaMapeada);
                } else {
                    break;
                }

                iteraciones++;
            }

            this.resumenAgentesPorTurno = turnosRequeridos;

            console.log('--- ✅ Agentes Calculados por Bloque de Turno ---');
            console.table(turnosRequeridos);

            return turnosRequeridos;
        },

        tiempoAMinutos(tiempoStr) {
            if (!tiempoStr) return 0;
            const [h, m] = tiempoStr.split(':').map(Number);
            return h * 60 + m;
        },

        mapearCoberturaTurno(turno, demandaIndexada) {
            const INTERVALO_MINUTOS = 30;

            const inicioTurnoMin = this.tiempoAMinutos(turno.intervalo_inicio);
            const finTurnoMin = this.tiempoAMinutos(turno.intervalo_fin);

            const cobertura = new Array(demandaIndexada.length).fill(0);

            demandaIndexada.forEach((demandaItem, index) => {
                if (turno.dias_aplicables.includes(demandaItem.dia)) {
                    const inicioIntervaloMin = demandaItem.inicioMinutos;
                    const finIntervaloMin = inicioIntervaloMin + INTERVALO_MINUTOS;

                    const estaDentroTurno = inicioIntervaloMin >= inicioTurnoMin && finIntervaloMin <= finTurnoMin;

                    if (estaDentroTurno) {
                        cobertura[index] = 1;
                    }
                }
            });
            return cobertura;
        },

        haySubCobertura(demandaIndexada, coberturaActual) {
            return demandaIndexada.some((item, index) => item.programados > coberturaActual[index]);
        },

        evaluarImpacto(demandaIndexada, coberturaActual, coberturaTurnoMapeada) {
            let impactoTotal = 0;
            let maxBrechaCubierta = 0;

            demandaIndexada.forEach((item, index) => {
                const brecha = Math.max(0, item.programados - coberturaActual[index]);

                if (coberturaTurnoMapeada[index] === 1 && brecha > 0) {
                    impactoTotal += 1;
                    maxBrechaCubierta = Math.max(maxBrechaCubierta, brecha);
                }
            });

            return impactoTotal * 100 + maxBrechaCubierta;
        },

        sumarCobertura(coberturaActual, coberturaTurnoMapeada) {
            return coberturaActual.map((val, index) => val + coberturaTurnoMapeada[index]);
        },

        indexarDemanda(demanda) {
            const ordenDias = { 'Lunes': 0, 'Martes': 1, 'Miércoles': 2, 'Jueves': 3, 'Viernes': 4, 'Sábado': 5, 'Domingo': 6 };

            const demandaOrdenada = demanda.sort((a, b) => {
                const diaA = ordenDias[a.dia_semana];
                const diaB = ordenDias[b.dia_semana];
                if (diaA !== diaB) return diaA - diaB;

                const inicioA = this.tiempoAMinutos(a.intervalo_inicio);
                const inicioB = this.tiempoAMinutos(b.intervalo_inicio);
                return inicioA - inicioB;
            });

            return demandaOrdenada.map(item => ({
                id: `${item.dia_semana}_${item.intervalo_inicio}`,
                programados: item.programados,
                dia: item.dia_semana,
                inicioMinutos: this.tiempoAMinutos(item.intervalo_inicio)
            }));
        }

    },
}
export default Planning